import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import SubscriptionList from './subscribtionList.tsx/SubscriptionList'
import BuilderLayout from '../layouts/builderLayout/BuilderLayout'
import { Container } from './Styled'
import PaymentList from './paymentList/PaymentList'
import { Space } from 'antd'
import BillList from './billList/BillList'
import CreditCardPreview from './creditCardPreview/CreditCardPreview'
import useSWR from 'swr'
import ApiManager from '../../business/services/ApiManager'
import PaymentMethodList from './paymentMethodList/PaymentMethodList'
import UpcomingInvoice from './upcomingInvoice/UpcomingInvoice';

const Billing = () => {
    return (
        <BuilderLayout
            onBackDestination="/"
            title={'Facturation'}
            subTitle={'Suivez votre consommation'}
        >
            <Container>
                    <Space style={{width: "40%"}} direction="vertical">
                        <UpcomingInvoice/>
                        <PaymentMethodList />
                    </Space>
                    <Space direction="vertical">
                        <SubscriptionList />
                        <PaymentList />
                        <BillList />
                    </Space>
            </Container>
        </BuilderLayout>
    )
}

export default Billing
